import React from "react";
import DashboardLayout from "../components/DashboardLayout";
import { useAuth } from "../contexts/AuthContext";
import { useI18n } from "../contexts/I18nContext";

export default function Settings() {
  const { user } = useAuth();
  const { t, lang } = useI18n();
  return (
    <DashboardLayout>
      <div className="max-w-2xl">
        <div className="kicker">Dikigoros.io</div>
        <h1 className="mt-2 font-display font-bold text-3xl md:text-4xl text-slate-900">{lang === "el" ? "Ρυθμίσεις" : "Settings"}</h1>

        <div className="mt-8 card-premium p-8 space-y-4" data-testid="settings-profile">
          <div className="kicker !text-slate-500">{lang === "el" ? "Προφίλ" : "Profile"}</div>
          <div className="grid grid-cols-2 gap-6 text-sm">
            <div>
              <div className="text-slate-500 mb-1">{t("auth.fullName")}</div>
              <div className="text-slate-900 font-medium">{user?.full_name}</div>
            </div>
            <div>
              <div className="text-slate-500 mb-1">{t("auth.email")}</div>
              <div className="text-slate-900 font-medium">{user?.email}</div>
            </div>
            <div>
              <div className="text-slate-500 mb-1">{t("auth.firm")}</div>
              <div className="text-slate-900 font-medium">{user?.firm_name || "—"}</div>
            </div>
            <div>
              <div className="text-slate-500 mb-1">{t("dash.plan")}</div>
              <div className="text-slate-900 font-medium">{user?.plan || "Free"}</div>
            </div>
          </div>
        </div>
      </div>
    </DashboardLayout>
  );
}
